<template>
    <div class="com-item corporateValues-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">
                <div class="corporateValues-module__inner">


                      <div class="public-module_title" v-if="W.enTitle || W.cnTitle">
                            <h2 class="module-cn" v-if="W.cnTitle">{{ W.cnTitle }}</h2>
                            <div class="module-en" v-if="W.enTitle">
                                <p class="module-line"></p>
                                {{ W.enTitle }}
                            </div>
                        </div>



                    <div class="corporateValues-module__body">
                        <div class="corporateValues-module__left">
                            <div class="corporateValues-module__value" v-for="(item, idx) in W.values" :key="'v' + idx">
                                <div class="corporateValues-module__value-icon">
                                    <img v-if="item.iconUrl" :src="item.iconUrl" alt="" />
                                </div>
                                <div class="corporateValues-module__value-text">
                                    <p class="corporateValues-module__value-title">{{ item.title }}</p>
                                    <p class="corporateValues-module__value-desc">{{ item.desc }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="corporateValues-module__right">
                            <div class="corporateValues-module__image" v-for="(item, idx) in W.images" :key="'i' + idx">
                                <div class="corporateValues-module__image-wrap" v-if="item.imgUrl">
                                    <img :src="item.imgUrl" alt="" />
                                </div>
                                <p class="corporateValues-module__image-title">{{ item.title }}</p>
                                <p class="corporateValues-module__image-desc">{{ item.desc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEFAULT_IMG = 'https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202607/ScreenShot_2026-07-03_152303_32803152310271.png'

export default {
    name: 'corporateValues-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'corporateValues',
                    Title: '企业价值观',
                    MID: 32,
                    ModuleName: 'corporateValuesModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            defaultData: {
                bgColor: '',
                textColor: '',
                enTitle: 'CORPORATE VALUES',
                cnTitle: '企业价值观',
                values: [
                    { iconUrl: DEFAULT_IMG, title: '客户至上', desc: '以客户需求为导向\n提供优质的产品与服务' },
                    { iconUrl: DEFAULT_IMG, title: '创新驱动', desc: '持续技术创新\n推动行业进步' },
                    { iconUrl: DEFAULT_IMG, title: '品质为本', desc: '严格的质量控制体系\n确保产品卓越可靠' },
                    { iconUrl: DEFAULT_IMG, title: '合作共赢', desc: '与合作伙伴共同成长\n共赢未来' }
                ],
                images: [
                    { imgUrl: DEFAULT_IMG, title: '研发中心', desc: '专业研发团队，持续创新突破' },
                    { imgUrl: DEFAULT_IMG, title: '智能生产', desc: '先进设备与 6S 标准车间' },
                    { imgUrl: DEFAULT_IMG, title: '质量检测', desc: '多重检测体系，质量层层把关' },
                    { imgUrl: DEFAULT_IMG, title: '全球服务', desc: '完善的服务体系，快速响应支持' }
                ]
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.values) || !this.modata.WContent.values.length) {
            this.$set(this.modata.WContent, 'values', JSON.parse(JSON.stringify(this.defaultData.values)))
        }
        if (!Array.isArray(this.modata.WContent.images) || !this.modata.WContent.images.length) {
            this.$set(this.modata.WContent, 'images', JSON.parse(JSON.stringify(this.defaultData.images)))
        }
    },
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.corporateValues-module {
    margin-bottom: 30px;
    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 3% 0 2%;
    }


    .corporateValues-module__body {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: center;
    }

    .corporateValues-module__left {
        flex: none;
        min-width: 20%;
        max-width: 35%;
        box-sizing: border-box;
        padding-right: 4%;
        align-self: center;
    }

    .corporateValues-module__right {
        flex: 1;
        max-width: 70%;
        min-width: 0;
    }

    .corporateValues-module__value {
        display: flex;
        align-items: flex-start;
        margin-bottom: 40px;
    }

    .corporateValues-module__value-icon {
        width: 48px;
        // height: 48px;
        flex: none;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
            // max-height: 100%;
        }
    }

    .corporateValues-module__value-text {
        flex: 1;
        min-width: 0;
    }

    .corporateValues-module__value-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 6px;
    }

    .corporateValues-module__value-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.7;
        margin: 0;
        white-space: pre-wrap;
    }

    .corporateValues-module__image {
        display: inline-block;
        width: calc(50% - 12px);
        margin-bottom: 24px;
        vertical-align: top;

        &:nth-child(odd) {
            margin-right: 24px;
        }
    }

    .corporateValues-module__image-wrap {
        width: 100%;
        height: 195px;
        overflow: hidden;
        background: #f5f5f5;
        border-radius: 4px;
        margin-bottom: 8px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .corporateValues-module__image-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 4px;
    }

    .corporateValues-module__image-desc {
        font-size: 13px;
        color: #999;
        line-height: 1.6;
        margin: 0;
    }
}

@media screen and (max-width: 768px) {
    .corporateValues-module {
        .corporateValues-module__body {
            flex-direction: column;
        }

        .corporateValues-module__left {
            flex: 0 0 100%;
            max-width: 100%;
            padding-right: 0;
            margin-bottom: 0;
            display: flex;
            flex-flow: row wrap;
            .corporateValues-module__value{
                width: 49%;
            }
            .corporateValues-module__value-desc{
                font-size: 16px;
            }
             .corporateValues-module__value-icon{
                width: 42px;
             }
        }

        .corporateValues-module__right {
            flex: 0 0 100%;
            width: 100%;
            max-width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        .corporateValues-module__image {
          width: 48.2%;
           box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
            margin-bottom: 15px;
            margin-right: 0 !important;
            padding-bottom: 10px;
        }
         .corporateValues-module__image-title{
            padding-left: 10px;
         }
         .corporateValues-module__image-desc{
            padding-left: 10px;
            font-size: 15px;
         }
    }
}
</style>